import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { InputDataModel } from 'dg-dynamic-grid-lib';
import {
  ComboPropConfig,
  DataPropConfig,
  getValidations,
  InputType,
  isCompareInput,
  isRangeInput,
} from 'dg-input-lib';
import { CommonComponent } from '../common/common.component';
import { AppGenServiceService } from '../service/app-gen-service.service';
import { CommonService } from '../service/common.service';
import { ExecutionService } from '../service/execution.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
}
@Component({
  selector: 'app-app-gen-tab',
  templateUrl: './app-gen-tab.component.html',
  styleUrls: ['./app-gen-tab.component.scss'],
})
export class AppGenTabComponent implements OnInit {
  inputDataPropConfig: DataPropConfig = {
    idProp: 'fieldId',
    typeProp: 'fieldType',
    nameProp: 'label',
    placeholderProp: 'placeholder',
    requiredProp: 'isMandatory',
    comboProp: 'comboMapValues',
    validationsProp: 'validations',
    disabledProp: 'enableDisable',
    minLengthProp: 'minLength',
    maxLengthProp: 'maxLength',
    hintProp: 'matHint',
  };

  comboPropConfig: ComboPropConfig = {
    labelProp: 'optionText',
    valueProp: 'optionValue',
    rangeProp: 'isRange',
    disabledProp: 'optionDisabled',
    iconProp: 'optionIcon',
  };

  @Input() tabData: any;
  @Input() attribute: any;
  @Input() tabObject: any;
  @Input() eventId: any;

  @ViewChild(CommonComponent) appCommon: CommonComponent;
  showLabel = true;
  tabButton: any;
  formGroup: any = {};
  getDataFromRouting: boolean;
  tid: any;
  @Output() appGenDataEmit = new EventEmitter<any>();
  tabLength: any;
  constructor(
    private router: Router,
    private http: HttpClient,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private appGenServiceService: AppGenServiceService,
    private execution: ExecutionService,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    //-------For Tab Button--start

    if (this.tabData.length < 1) {
      this.tabButton = false;
    }
    this.buttonControl(this.tabData);
    this.attribute.selectedIndex = 0;
  }

  onInputChange = (data, eventName) => {
    // Application Developer's code ;-)
    console.log('event change = ', data);
    // console.log('form validity: ', data, this.appGenStepperFormGroup);
    if (data?.fieldType == 0) {
      let tempDate = this.commonService.appGenFormGroup.controls[data.fieldId]
        .value;
      if (tempDate != null) {
        tempDate = this.datePipe.transform(new Date(tempDate), 'yyyy-MM-dd');
        this.commonService.appGenFormGroup.controls[data.fieldId].setValue(
          tempDate
        );

        // For date valildation
        data?.attribute?.validations?.forEach((comp) => {
          this.commonService.dateValidation(
            comp.validationId,
            comp.cmpFormId,
            comp.otherCmpFormId,
            data,
            true
          );
        });
      }
    }
    this.appGenServiceService.setAppGenData(
      data.fieldId,
      this.commonService.appGenFormGroup.controls[data.fieldId].value
    );
    this.appGenDataEmit.emit(this.appGenServiceService.appGenData);

    data?.cmnFormFieldEventList?.forEach((event) => {
      if (event.eventName == eventName) {
        this.commonService.findcomboStringObj(this.tabData, data);
        this.execution.executeEventService(
          event.cmnEventExecutionList,
          this.commonService.appGenFormGroup,
          data,
          null,
          this.tid,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
      }
    });
    this.buttonControl(this.tabData);
  };

  buttonControl(tabsData) {
    this.tabLength = tabsData.filter((object) => {
      return object.attribute['hideShow'] == true;
    });
    // console.log("show length >",this.tabLength.length );
    if (this.tabData.length - this.tabLength.length < 2) {
      this.commonService.nextTab = true;
    } else {
      this.commonService.nextTab = false;
    }
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent, data) {
    //  console.log(tabChangeEvent.index);
    //  console.log(data);
    this.buttonControl(data.children);
    this.attribute.selectedIndex = tabChangeEvent.index;

    let tabFieldId = null;
    data.children?.forEach((exe) => {
      if (exe.gujLbl == tabChangeEvent.tab.textLabel) {
        tabFieldId = exe.fieldId;
      }
    });

    if (
      this.tabData.length - this.tabLength.length ==
      this.attribute.selectedIndex
    ) {
      this.commonService.nextTab = true;
    } else if (
      this.tabData.length - 1 - this.tabLength.length ==
      this.attribute.selectedIndex
    ) {
      this.commonService.nextTab = true;
      // console.log(this.attribute.selectedIndex);
      // console.log(this.tabLength.length);
    } else if (this.attribute.selectedIndex + 1 == this.tabData.length) {
      this.commonService.nextTab = true;
    } else {
      this.commonService.nextTab = false;
    }

    data?.cmnFormFieldEventList?.forEach((event) => {
      this.execution.executeEventService(
        event.cmnEventExecutionList,
        this.commonService.appGenFormGroup,
        data,
        null,
        this.tid,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        tabFieldId
      );
    });
  }

  onNext() {
    this.attribute.selectedIndex
      ? this.attribute.selectedIndex
      : (this.attribute.selectedIndex = null);
    if (this.attribute.selectedIndex < this.tabData.length - 1) {
      this.attribute.selectedIndex++;
    }
  }
  onPrev() {
    if (this.attribute.selectedIndex > 0) {
      this.attribute.selectedIndex--;
    }
  }
  appGenDataEmitFromCheckList(event) {
    this.appGenDataEmit.emit(this.appGenServiceService.appGenData);
  }
  appGenDataEmitFromTab(event) {
    this.appGenDataEmit.emit(this.appGenServiceService.appGenData);
  }
  appGenDataFromCommon(event) {
    this.appGenDataEmit.emit(this.appGenServiceService.appGenData);
  }
  onKeyPress(event) {
    return this.commonService.hashRestrict(event);
  }
}
